<template>
  <modal
    size="md"
    ref="modal"
    :show="show"
    :hide-footer="true"
    :hide-header="true"
    :scrollable="false"
    :show-close-icon="true"
    modal-class="tomb-modal"
    @hidden="$emit('input', false)"
  >
    <div class="icon-wrapper flex-center">
      <div class="icon-container">
        <i class="logo-round-icon"></i>
      </div>
    </div>
    <div class="pt-5">
      <div class="header text-extra-large bold text-center">
        <slot v-if="$slots.heading" name="heading"></slot>
        <template v-else>
          {{ heading }}
        </template>
      </div>
      <slot></slot>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal.vue'

/**
 * This is a modal that has a tomb at the top. Tomb may contain an icon.
 */
export default {
  name: 'TombModal',
  props: ['show', 'heading'],
  model: {
    prop: 'show'
  },
  components: { Modal },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.icon-wrapper {
  @include dimension(100px, 100px);
  border-radius: 50%;
  position: absolute;
  background: $documentColor;
  top: -50px;
  left: 50%;
  transform: translateX(-50%);
}
.icon-container {
  @include dimension(70px, 70px);
  border-radius: 50%;
  i {
    @include dimension(70px, 70px);
  }
}
</style>
<style lang="scss">
.tomb-modal {
  margin-top: 90px;
}
</style>
